import { createSelector } from 'reselect';

import { RootState } from '@store/type';
import { EhrSyncState } from './reducer';

export const getEhrSync = ({ ehrSync }: RootState): EhrSyncState => ehrSync;
export const getListEhrSync = createSelector(getEhrSync, ({ list }) => list);
export const isListSync = createSelector(getListEhrSync, ({ sync }) => sync);
export const getListEhrSyncIsLoading = createSelector(
  getListEhrSync,
  ({ loading }) => loading,
);
export const getListEhrSyncError = createSelector(
  getListEhrSync,
  ({ error }) => error,
);
export const getListEhrSyncItems = createSelector(
  getListEhrSync,
  ({ items }) => items,
);
export const getListEhrSyncMeta = createSelector(
  getListEhrSync,
  ({ meta }) => meta,
);
export const getListEhrSyncCount = createSelector(
  getListEhrSyncMeta,
  ({ totalItems }) => totalItems,
);
export const getListEhrSyncLastUpdated = createSelector(
  getListEhrSync,
  ({ lastUpdated }) => lastUpdated,
);
export const getModalMatches = createSelector(
  getEhrSync,
  ({ modalMatches }) => modalMatches,
);
export const getModalMatchesIsOpen = createSelector(
  getModalMatches,
  ({ isOpen }) => isOpen,
);
export const getModalMatchesIsOpenNotFound = createSelector(
  getModalMatchesIsOpen,
  ({ notFound }) => notFound,
);
export const getModalMatchesIsOpenManyMatches = createSelector(
  getModalMatchesIsOpen,
  ({ manyMatches }) => manyMatches,
);
export const getModalMatchesIsLoading = createSelector(
  getModalMatches,
  ({ loading }) => loading,
);
export const getModalMatchesIsSubmitting = createSelector(
  getModalMatches,
  ({ submitting }) => submitting,
);
export const getModalMatchesError = createSelector(
  getModalMatches,
  ({ error }) => error,
);
export const getModalMatchesItems = createSelector(
  getModalMatches,
  ({ items }) => items,
);
export const getModalNotFound = createSelector(
  getModalMatches,
  ({ title, message }) => ({ title, message }),
);
export const getModalMatchesSelectLeadId = createSelector(
  getModalMatches,
  ({ selectLeadId }) => selectLeadId,
);
export const getSyncItems = createSelector(
  getEhrSync,
  ({ syncItems }) => syncItems,
);

export const isSyncLeadToEhr = createSelector(
  [getSyncItems, (__: RootState, id: string) => id],
  (syncItems, leadId) => syncItems.includes(leadId),
);
